module.exports = __webpack_public_path__ + "img/tennis.785e9e1b.png";